"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./CustomizeBenefits.css");

var _react = _interopRequireDefault(require("react"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "customize-benefits-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "customize-benefits"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "customize-image-wrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "customize-image",
    alt: "Customize your benefits",
    src: require("../assets/redesign2020/products/customize.png")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "customize-body"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "chevron",
    className: "chevron",
    src: require("../assets/redesign2020/chevron.svg")
  }), /*#__PURE__*/_react.default.createElement("h2", {
    className: "customize-header"
  }, "Customize your benefits, ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "maximize your impact"), "."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
    tag: "p",
    sharedKey: "marketing2020/customizeBenefits",
    contentKey: "customizeBenefitsBody1",
    className: "customize-body-text"
  }), /*#__PURE__*/_react.default.createElement("h3", {
    className: "customize-subheader"
  }, "Our exceptional service means ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "less stress"), " for you."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
    tag: "p",
    sharedKey: "marketing2020/customizeBenefits",
    contentKey: "customizeBenefitsBody2",
    className: "customize-body-text"
  }))));
};

exports.default = _default;